module.exports = ".panel-body {\r\n    padding: 2rem 1.5rem;\r\n  }\r\n  "